import { Injectable } from '@angular/core';
import { ApiHttpService } from 'src/app/core/services/api-http.service';
import { ApiEndpointsService } from 'src/app/core/services/api-endpoints.service';
import { QueryStringParameters } from 'src/app/shared/classes/query-string-parameters';

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private apiHttpService: ApiHttpService, private apiEndpointsService: ApiEndpointsService) {}

  public loginUser(body: any) {
    const url: string = this.apiEndpointsService.createUrl('auth/login');
    return this.apiHttpService.post(url, body);
  }

  public getUserInfo() {
    const url: string = this.apiEndpointsService.createUrl('user/me');
    return this.apiHttpService.get(url);
  }

  public getAllUser(
    page?: number,
    limit?: number,
    text?: string,
    settingChain?: string,
    search_text_key?: string,
    search_text_value?: string,
    sort_column?: string,
    sort_value?: string,
  ) {
    const url: string = this.apiEndpointsService.createUrlWithQueryParameters('user', (qs: QueryStringParameters) => {
      if (!sort_column) sort_column = '_id';
      if (!sort_value) sort_value = '-1';
      limit ? qs.push('limit', limit) : false, page ? qs.push('page', page) : false, text ? qs.push('text', text) : false, settingChain ? qs.push('chain_id', settingChain) : false;
      if (search_text_key && search_text_value) qs.push(search_text_key, search_text_value);
      qs.push('sort_by', '{"' + sort_column + '": ' + sort_value + '}');
    });
    return this.apiHttpService.get(url);
  }

  public getUserById(id: string) {
    const url: string = this.apiEndpointsService.createUrlWithPathVariables('user', [id]);
    return this.apiHttpService.get(url);
  }
  public refreshToken(body: any) {
    const url: string = this.apiEndpointsService.createUrl('auth/refresh-token');
    return this.apiHttpService.post(url, body);
  }
  public getCustomerById(id: string) {
    const url: string = this.apiEndpointsService.createUrlWithPathVariables('customer/view', [id]);
    return this.apiHttpService.get(url);
  }

  public createUser(body: any) {
    const url: string = this.apiEndpointsService.createUrl('user');
    return this.apiHttpService.post(url, body);
  }

  public createCustomerGroup(body: any) {
    const url: string = this.apiEndpointsService.createUrl('customer-group');
    return this.apiHttpService.post(url, body);
  }

  public getAllCustomerGroup(chainId?: string, page?: number, limit?: number, text?: string) {
    const url: string = this.apiEndpointsService.createUrlWithQueryParameters('customer-group', (qs: QueryStringParameters) => {
      chainId ? qs.push('chain_id', chainId) : false,
        limit ? qs.push('limit', limit) : false,
        page ? qs.push('page', page) : false,
        text ? qs.push('text', text) : false,
        qs.push('sort_by', '{"_id":-1}');
    });
    return this.apiHttpService.get(url);
  }

  public getCustomerGroupById(id: string) {
    const url: string = this.apiEndpointsService.createUrlWithPathVariables('customer-group', [id]);
    return this.apiHttpService.get(url);
  }

  public updateCustomerGroupById(id: string, body: object) {
    const url: string = this.apiEndpointsService.createUrlWithPathVariables('customer-group', [id]);
    return this.apiHttpService.put(url, body);
  }

  public deleteCustomerGroupById(id: string) {
    const url: string = this.apiEndpointsService.createUrlWithPathVariables('customer-group', [id]);
    return this.apiHttpService.delete(url);
  }

  public createCustomerGroupAssgin(body: any) {
    const url: string = this.apiEndpointsService.createUrl('customer-group-detail');
    return this.apiHttpService.post(url, body);
  }

  public getAllAssginCustomerGroup(page?: number, limit?: number, text?: string) {
    const url: string = this.apiEndpointsService.createUrlWithQueryParameters('customer-group-detail', (qs: QueryStringParameters) => {
      limit ? qs.push('limit', limit) : false, page ? qs.push('page', page) : false, text ? qs.push('text', text) : false, qs.push('sort_by', '{"_id":-1}');
    });
    return this.apiHttpService.get(url);
  }

  public getAssginCustomerGroupById(id: string) {
    const url: string = this.apiEndpointsService.createUrlWithPathVariables('customer-group-detail', [id]);
    return this.apiHttpService.get(url);
  }

  public updateAssginCustomerGroupById(id: string, body: object) {
    const url: string = this.apiEndpointsService.createUrlWithPathVariables('customer-group-detail', [id]);
    return this.apiHttpService.put(url, body);
  }

  public deleteAssginCustomerGroupById(id: string) {
    const url: string = this.apiEndpointsService.createUrlWithPathVariables('customer-group-detail', [id]);
    return this.apiHttpService.delete(url);
  }

  public deleteUserById(id: string) {
    const url: string = this.apiEndpointsService.createUrlWithPathVariables('user', [id]);
    return this.apiHttpService.delete(url);
  }

  public deleteCustomerById(id: string) {
    const url: string = this.apiEndpointsService.createUrlWithPathVariables('customer', [id]);
    return this.apiHttpService.delete(url);
  }

  public updateUserById(id: string, body: object) {
    const url: string = this.apiEndpointsService.createUrlWithPathVariables('user', [id]);
    return this.apiHttpService.put(url, body);
  }

  public createCustomer(body: any) {
    const url: string = this.apiEndpointsService.createUrl('customer/register');
    return this.apiHttpService.post(url, body);
  }

  public updateCustomerId(id: string, body: object) {
    const url: string = this.apiEndpointsService.createUrlWithPathVariables('customer/profile-update', [id]);
    return this.apiHttpService.put(url, body);
  }

  public updateCustomerProfileById(body: object) {
    const url: string = this.apiEndpointsService.createUrl('customer/status-update');
    return this.apiHttpService.put(url, body);
  }

  //customer
  public getAllCustomer(
    page?: number,
    limit?: number,
    text?: string,
    settingChain?: string,
    search_text_key?: string,
    search_text_value?: string,
    sort_column?: string,
    sort_value?: string,
    profile_type?: string,
  ) {
    console.log('getAllCustomer', text);
    const url: string = this.apiEndpointsService.createUrlWithQueryParameters('customer', (qs: QueryStringParameters) => {
      if (!sort_column) sort_column = '_id';
      if (!sort_value) sort_value = '-1';
      limit ? qs.push('limit', limit) : false;
      page ? qs.push('page', page) : false;
      text ? qs.push('text', text) : false;
      settingChain ? qs.push('chain_id', settingChain) : false;
      profile_type ? qs.push('profile_type', profile_type) : false;
      if (search_text_key && search_text_value) qs.push(search_text_key, search_text_value);
      qs.push('sort_by', '{"' + sort_column + '": ' + sort_value + '}');
      qs.push('is_verified', true);
    });
    return this.apiHttpService.get(url);
  }

  public getAllCustomerPendingRequest(
    page?: number,
    limit?: number,
    text?: string,
    settingChain?: string,
    search_text_key?: string,
    search_text_value?: string,
    sort_column?: string,
    sort_value?: string,
  ) {
    const url: string = this.apiEndpointsService.createUrlWithQueryParameters('customer', (qs: QueryStringParameters) => {
      if (!sort_column) sort_column = '_id';
      if (!sort_value) sort_value = '-1';
      limit ? qs.push('limit', limit) : false;
      page ? qs.push('page', page) : false;
      text ? qs.push('text', text) : false;
      settingChain ? qs.push('chain_id', settingChain) : false;
      // qs.push('profile_type', 'B');
      qs.push('credit_verification_status', 'P');
      if (search_text_key && search_text_value) qs.push(search_text_key, search_text_value);
      qs.push('sort_by', '{"' + sort_column + '": ' + sort_value + '}');
    });
    return this.apiHttpService.get(url);
  }

  public getUserByRolse(restaurant_id: string, roles: string) {
    const url: string = this.apiEndpointsService.createUrlWithQueryParameters('user', (qs: QueryStringParameters) => {
      restaurant_id ? qs.push('restaurant_id', restaurant_id) : false, roles ? qs.push('roles', roles) : false;
    });
    return this.apiHttpService.get(url);
  }
}
